module.exports = __webpack_public_path__ + "img/s5-1.d0c63842.jpg";